import { Component } from '@angular/core';

@Component({
    selector: 'app-network-error-page',
    template: `
    <div class="d-flex align-items-center justify-content-center vw-100 vh-100 bg-gradient bg-light p-5">
      <div class="d-flex flex-column align-items-center text-danger text-center">
        <span class="material-icons icon-large">priority_high</span>
        <span class="fs-2 mb-4" i18n>Es besteht keine Internetverbindung.</span>
        <span class="fs-2" i18n>Bitte prüfe deine Verbindung und versuche es erneut.</span>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
      position: absolute;
      z-index: 1100;
    }

    .icon-large {
      font-size: 8rem;
    }
  `],
    standalone: false
})
export class NetworkErrorPage {
}
